import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../auth/services/auth.service';
import { Router } from '@angular/router';
import { APP_ROUTES } from '../../constants/routes.const';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CardModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    FloatLabelModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  private readonly fb = inject(FormBuilder);
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly messages = inject(MessageService);

  loading = signal(false);

  form = this.fb.nonNullable.group({
    correo: ['', [Validators.required, Validators.email]],
    contrasena: ['', [Validators.required, Validators.minLength(6)]],
  });

  showError = (controlName: 'correo' | 'contrasena') => {
    const c = this.form.controls[controlName];
    return c.invalid && (c.dirty || c.touched);
  };

  correoError = computed(() => {
    const c = this.form.controls.correo;
    if (c.hasError('required')) return 'El correo es obligatorio.';
    if (c.hasError('email')) return 'Formato de correo no válido.';
    return '';
  });

  onSubmit() {
    if (this.form.invalid || this.loading()) return;

    this.loading.set(true);
    const credentials = this.form.getRawValue();

    this.auth.login(credentials).subscribe({
      next: () => {
        this.loading.set(false);
        this.router.navigateByUrl(APP_ROUTES.DASHBOARD).then();
      },
      error: (err) => {
        this.loading.set(false);
        this.messages.add({
          severity: 'error',
          summary: 'No se pudo iniciar sesión',
          detail: err?.error?.message ?? 'Revisa tus credenciales e inténtalo de nuevo.',
          life: 3500,
        });
      },
    });
  }
}
